import { connect } from 'react-redux';
import { getIsPaymentsConfigured
// @ts-expect-error types missing
} from 'FormsUI/selectors/Payments';
// @ts-expect-error types missing
import { getPaymentField, getFormGuid } from 'FormsUI/selectors/FormDefinition';
import { updateOptionsPanelNavigationItem } from 'FormsUI/actions/OptionsPanelNavigationItems';
import PaymentsSection from './PaymentsSection';
import { jsx as _jsx } from "react/jsx-runtime";
const SubmitButtonPaymentLink = ({
  paymentField,
  isPaymentsConfigured
}) => {
  if (!isPaymentsConfigured) return null;
  if (!paymentField) return null;
  return /*#__PURE__*/_jsx(PaymentsSection, {});
};
const mapStateToProps = state => ({
  formGuid: getFormGuid(state),
  paymentField: getPaymentField(state),
  isPaymentsConfigured: getIsPaymentsConfigured(state)
});
const actionCreators = {
  setActiveNavItem: updateOptionsPanelNavigationItem
};
export default connect(mapStateToProps, actionCreators)(SubmitButtonPaymentLink);